export const Logo = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <linearGradient id="ph-grad" x1="4" y1="44" x2="44" y2="4" gradientUnits="userSpaceOnUse">
        <stop stopColor="#EA580C" />
        <stop offset="1" stopColor="#FB923C" />
      </linearGradient>
    </defs>
    {/* ascending pixel-hatch stairs */}
    <rect x="5" y="33" width="8" height="8" rx="1.5" fill="url(#ph-grad)" opacity="0.55" />
    <rect x="14" y="24" width="8" height="17" rx="1.5" fill="url(#ph-grad)" opacity="0.75" />
    <rect x="23" y="15" width="8" height="26" rx="1.5" fill="url(#ph-grad)" opacity="0.9" />
    <rect x="32" y="6" width="8" height="35" rx="1.5" fill="url(#ph-grad)" />
    <path d="M6 20 L40 6" stroke="#FB923C" strokeWidth="1.4" strokeLinecap="round" opacity="0.5" />
  </svg>
);

export const LogoWordmark = ({ light = false }) => (
  <div className="flex items-center gap-2.5 select-none">
    <Logo className="h-8 w-8" />
    <span className="whitespace-nowrap font-head text-xl font-extrabold tracking-tight text-white">
      Pixel<span className="text-orange-400">-</span>Hatch
    </span>
  </div>
);
